import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_qr_stream = _resolveComponent("qr-stream");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_qr_stream, {
    onDecode: $options.onDecode,
    onInit: $options.onInit,
    class: "mb"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("div", null, [_createElementVNode("div", {
      class: "qr-scanner"
    }, [_createElementVNode("div", {
      class: "box"
    }, [_createElementVNode("div", {
      class: "line"
    }), _createElementVNode("div", {
      class: "angle"
    })]), _createElementVNode("div", {
      class: "txt"
    }, " 将二维码/条码放入框内，即自动扫描 ")])], -1)])),
    _: 1,
    __: [0]
  }, 8, ["onDecode", "onInit"])]);
}